import FormComponent from "../../components/global/FormComponent";
import Error404 from "../../pages/Error404";

const formField = [
  {
    field: {
      type: "text",
      title: "Name",
      id: "name",
      name: "name",
      placeholder: "Your Name",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "Name is required",
      },
    },
  },
  {
    field: {
      type: "text",
      title: "User Name",
      id: "username",
      name: "username",
      placeholder: "Your User Name",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "User Name is required",
      },
    },
  },
  {
    field: {
      type: "password",
      title: "Password",
      id: "password",
      name: "password",
      placeholder: "Your Password",
      required: true,
      error: {
        condition: (value) => value.trim() === "" || value.length < 8,
        message: "Password should be at least 8 characters long",
      },
    },
  },
];

const EditSubscriber = ({
  handleUpdate,
  closePopup,
  formFieldValues,
  role,
}) => {
  return (
    <>
      {role === "admin" ? (
        <FormComponent
          formConfig={formField}
          buttonText={"Edit Now"}
          fieldValue={formFieldValues}
          handleAddOrUpdate={handleUpdate}
          closePopup={closePopup}
        />
      ) : (
        <Error404 />
      )}
    </>
  );
};

export default EditSubscriber;
